<template>
    <div>
        <b-card  v-if="consent.date">
            <b-row>
                <b-col>
                    Teacher Consent Total<br>
                   {{getDataConsentTrainerCount.total_t}} / {{getTrainerData.allteachers}}
                </b-col>
                <b-col>
                    Student Consent Total<br>
                      {{getDataConsentTrainerCount.total_s}} / {{getTrainerData.allstudents}}
                    </b-col>
                <b-col>
                    Parent/Guidian Consent Total<br>
                     {{getDataConsentTrainerCount.total_p}} / {{getTrainerData.allparents}}
                    </b-col>
            </b-row>
           
        </b-card>
      
    </div>  
</template>
<script>
import {mapGetters,mapActions} from "vuex";
export default {
    name:"DataConsentTrainer",
    data() {
        return {
            
        }
    },
    computed:{
    ...mapGetters({
        getDataConsentTrainerCount:"dataConsentTrainer/getDataConsentTrainerCount",
        getTrainerData:"dataConsentTrainer/getTrainerData",
        
        }),
    consent: {
      get() {
        return this.$store.state.extras.dataConsents;
      }
    }
  },
    methods:{
        ...mapActions({
            ADD_DATACONSENT:"dataConsentTrainer/ADD_DATACONSENT",
            ADD_TRAINERDATA:"dataConsentTrainer/ADD_TRAINERDATA",
            }),
        
    },
    mounted(){
        this.ADD_DATACONSENT();
        this.ADD_TRAINERDATA();
    }
}
</script>